import { render, staticRenderFns } from "./NewsNav.vue?vue&type=template&id=8055a624&scoped=true&"
import script from "./NewsNav.vue?vue&type=script&lang=js&"
export * from "./NewsNav.vue?vue&type=script&lang=js&"
import style0 from "./NewsNav.vue?vue&type=style&index=0&id=8055a624&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8055a624",
  null
  
)

export default component.exports